// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Iem7","amount":"Amount_amount__3JGZe","tip":"Amount_tip__3wOts","tipHeader":"Amount_tipHeader__ekcNe","tipsWrap":"Amount_tipsWrap__wFgJ4"};